import { ItemDetail, ItemDetailToExport } from '../domain/SummaryData';
import { removeDecimals } from '../domain/calculatePrice';

export default (items: ItemDetail[]): ItemDetailToExport[] => {
    return items.map(
        (item: ItemDetail): ItemDetailToExport => ({
            sku: item.sku,
            name: item.name,
            variantCode: item.variantCode,
            size: item.size,
            quantity: item.quantity.toString(),
            wholesalePrice: item.wholesalePrice,
            discountedPrice: removeDecimals(item.discountedPrice).toString(),
            packageSize: item.packageSize.toString(),
            subTotal: removeDecimals(item.subTotal).toString()
        })
    );
};



// WEBPACK FOOTER //
// ./src/view/createDetailsExcelData.ts